const Features = () => {
  return <div>Features</div>;
};
export default Features;
